import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { FileConstants, IconDefinitionConstants } from "utils/constants";
import { TextInputProps, ToggleProps } from "models/propTypes/wintFormPropsTypes";
import { DocumentationLogCreateFormProps } from "models/propTypes/advisorPropTypes";
import { StyleEnums } from "models/enums";
import { DocumentationLogFormTypes } from "models/formTypes";
//#endregion
//#region components
import {
  FileUploader,
  TextAreaInput,
  TextInput,
  VerticalFormField,
  Toggle,
  WintForm,
  HorizontalFormField,
  useWintForm,
} from "components/common/wintForms";
import { StaticInfoMessage } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const DocumentationLogCreateForm: ForwardRefRenderFunction<FormHandles, DocumentationLogCreateFormProps> = (
  props,
  ref
) => {
  const { onFormValidationChange, defaultValues, validationSchema, handleSubmit, onSubmitSuccess } = props;

  const { wintFormProps, connect, values } = useWintForm<DocumentationLogFormTypes.Create>({
    formRef: ref,
    defaultValues: defaultValues,
    validationSchema: validationSchema,
    handleSubmit: handleSubmit,
    onFormValidationChange: onFormValidationChange,
    onSubmitSuccess: onSubmitSuccess,
  });

  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<TextInputProps>
        Component={TextInput}
        {...connect("subject")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Subject)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.SubjectHelpText)}
        icon={IconDefinitionConstants.WTag}
        maxLength={512}
      />
      <VerticalFormField<TextInputProps>
        Component={TextAreaInput}
        {...connect("message")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Message)}
        icon={IconDefinitionConstants.WCommentDots}
      />
      <HorizontalFormField<ToggleProps>
        Component={Toggle}
        {...connect("isSupportTicket")}
        mainLabelGridSize={true}
        noOuterSpacing
        childGridSize={"auto"}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.CreateSupportCase)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Advisor.CreateSupportCaseDescription
        )}
      />
      {values.isSupportTicket && (
        <Grid item container>
          <StaticInfoMessage displayType={StyleEnums.DisplayType.Warning} fullWidth gutterBottom>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.SupportTicketWarning)}
          </StaticInfoMessage>
        </Grid>
      )}
      <VerticalFormField
        Component={FileUploader}
        {...connect("attachments")}
        filePreviewElementId={FileConstants.DialogFilePreviewPortalId}
      />
    </WintForm>
  );
};

export default forwardRef(DocumentationLogCreateForm);
